import { createListStore } from "./list";
import { IndicatorService } from "@/services/indicators";

export const useIndicatorsStore = createListStore(
  "indicators",
  IndicatorService
);
